import { useState } from "react";
import { api, courseImageUrl } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function SignatureUpload() {
  const { user, refreshUser } = useAuth();
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  if (!user || (user.role !== "instructor" && user.role !== "evaluador")) return null;

  const handleUpload = async (file: File | undefined) => {
    if (!file) return;
    setUploading(true);
    setError("");
    setSuccess(false);
    try {
      await api.uploadSignature(file);
      await refreshUser();
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Error al subir firma");
    }
    setUploading(false);
  };

  return (
    <div className="card">
      <h3 className="text-sm font-semibold text-[var(--color-text-primary)] mb-1">Firma digital para certificados</h3>
      <p className="text-xs text-[var(--color-text-muted)] mb-4">
        Suba una imagen PNG/JPG de su firma. Aparecerá en los certificados que emita como {user.role === "instructor" ? "instructor" : "evaluador"}.
      </p>
      {user.signature_url && (
        <div className="mb-4 p-3 bg-[var(--color-bg-tertiary)] rounded-xl inline-block">
          <img src={courseImageUrl(user.signature_url)} alt="Firma actual" className="h-16 object-contain" />
        </div>
      )}
      <input
        type="file"
        accept=".png,.jpg,.jpeg,.webp"
        disabled={uploading}
        onChange={(e) => handleUpload(e.target.files?.[0])}
        className="input-field"
      />
      {uploading && <p className="text-xs text-[var(--color-text-muted)] mt-2">Subiendo...</p>}
      {success && <p className="text-xs text-green-400 mt-2">Firma actualizada correctamente.</p>}
      {error && <p className="text-xs text-red-400 mt-2">{error}</p>}
    </div>
  );
}
